import React, { useState } from "react";

import {
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
} from "antd";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import MultiSelect from "../../../components/common/MultiSelect";
import FormAction from "../../../components/common/FormAction";
import Footer from "../../../components/common/Footer";

import { Propertiesunitscampaigns } from "../../../data/renewals";
import { showingTime } from "../../../utils/showingSettings";

import "./ShowingsSettings.css";

const ShowingsSettingsRightBar = [];

function ShowingsSettings() {
  const [value, setValue] = useState("allowall");
  const [virtualShowingChecked, setVirtualShowingChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [restrictShowingChecked, setRestrictShowingChecked] = useState(true);
  const [allowMultipleChecked, setAllowMultipleChecked] = useState(true);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
    if (value === "allowall") {
      setDisabled(false);
    }
    if (value === "allowonly") {
      setDisabled(true);
    }
  };
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Showings Settings" />
          <div className="showings-settings">
            <Form layout="vertical">
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Card title="General Showings Settings">
                    <Form.Item>
                      <p className="silver-text">
                        These settings apply to all showings.
                      </p>
                    </Form.Item>
                    <Form.Item>
                      <Checkbox>
                        Automatically cancel showings 1 hour before the
                        scheduled time if the prospect has not confirmed via
                        text
                      </Checkbox>
                    </Form.Item>
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="Virtual Showings">
                    <Form.Item>
                      <Checkbox
                        checked={virtualShowingChecked}
                        onChange={() =>
                          setVirtualShowingChecked(!virtualShowingChecked)
                        }
                      >
                        Enable Virtual Showings
                      </Checkbox>
                    </Form.Item>
                    {virtualShowingChecked ? (
                      <div className="margin-left radio-container">
                        <Radio.Group onChange={onChange} value={value}>
                          <Space direction="vertical">
                            <Radio value="allowall">
                              Allow scheduling Virtual Showings at all
                              properties
                            </Radio>
                            <Radio value="allowonly">
                              Allow scheduling Virtual Showings at only these
                              properties/property groups:
                            </Radio>
                          </Space>
                        </Radio.Group>
                        <Form.Item>
                          <MultiSelect
                            options={Propertiesunitscampaigns}
                            placeholder="Select..."
                            disabled={disabled}
                          />
                        </Form.Item>
                      </div>
                    ) : null}
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="Prospect-Scheduled Showings">
                    <Form.Item>
                      <p className="silver-text">
                        These settings apply to showings that prospects
                        self-schedule via showing invitations and your website.
                        They apply to both self-scheduled showings with an agent
                        and self-guided showings with a lockbox.
                      </p>
                    </Form.Item>
                    <Row>
                      <Col span={8}>
                        <Form.Item label="All prospect-scheduled showings are:">
                          <Select options={showingTime} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item>
                      <Checkbox>
                        When Virtual Showings are available, allow prospects to
                        chose either an In Person or Virtual Showing.
                      </Checkbox>
                    </Form.Item>
                    <Form.Item>
                      <Checkbox>
                        Allow prospects to self-schedule showings from website
                        listings
                      </Checkbox>
                    </Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={restrictShowingChecked}
                        onChange={() =>
                          setRestrictShowingChecked(!restrictShowingChecked)
                        }
                      >
                        Restrict showing availability
                      </Checkbox>
                    </Form.Item>
                    {restrictShowingChecked ? (
                      <div className="margin-left">
                        <Form.Item label="Number of days in advance a prospect can schedule a showing:">
                          <Input />
                        </Form.Item>
                      </div>
                    ) : null}
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="Self-Scheduled Showings with an Agent">
                    <Form.Item>
                      <p className="silver-text">
                        These settings only apply to showings that somebody is
                        assigned to.
                      </p>
                    </Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={allowMultipleChecked}
                        onChange={() =>
                          setAllowMultipleChecked(!allowMultipleChecked)
                        }
                      >
                        Allow multiple prospects to attend the same showing
                        appointment
                      </Checkbox>
                    </Form.Item>
                    {allowMultipleChecked ? (
                      <div className="margin-left">
                        <Form.Item>
                          <Checkbox>
                            Once a showing is scheduled, limit prospects to
                            joining existing showings
                          </Checkbox>
                        </Form.Item>
                      </div>
                    ) : null}
                  </Card>
                </Col>
                <Col span={24}>
                  <FormAction />
                </Col>
              </Row>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ShowingsSettingsRightBar} />
      </div>
    </>
  );
}

export default ShowingsSettings;
